import Airpods from "./Components/Airpods/Airpods";
import AppleCard from "./Components/AppleCard/AppleCard";
import AppleHoliday from "./Components/AppleHoliday/AppleHoliday";
import Footer from "./Components/Footer/Footer";
import Header from "./Components/Header/Header";
import Iphone14 from "./Components/Iphone14/Iphone14";
import IphonePro from "./Components/IphonePro/IphonePro";
import Watch from "./Components/Watch/Watch";
import Script from "./Components/Script";
import "./Components/Global.css";

function App() {
    return (
        <div>
            <Header />
            <Iphone14 />
            <AppleHoliday />
            <AppleCard />
            <IphonePro />
            <Airpods />
            <Watch />
            <Footer />
            <Script />
        </div>
    );
}

export default App;
